import { useTranslation } from "../i18n/i18n";
import StickyTitle from "../components/StickyTitle/StickyTitle";

const Terms = () => {
	const { translate } = useTranslation();
	const emailLink =
		"<a href='mailto:numerys.app@gmail.com' class='link-button'>numerys.app@gmail.com</a>";

	return (
		<div className="content">
			<StickyTitle title={translate("terms.title")} />
			<div className="page-content">
				<p className="legal-updated">{translate("terms.updated")}</p>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.editor")}</h2>
					<p
						dangerouslySetInnerHTML={{
							__html: translate("terms.content.editor", { emailLink }),
						}}
						className="legal-paragraph"
					/>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.scope")}</h2>
					<p className="legal-paragraph">{translate("terms.content.scope")}</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("terms.sections.acceptance")}
					</h2>
					<p className="legal-paragraph">
						{translate("terms.content.acceptance")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.access")}</h2>
					<p className="legal-paragraph">{translate("terms.content.access")}</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.data")}</h2>
					<p className="legal-paragraph">{translate("terms.content.data")}</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("terms.sections.intellectual")}
					</h2>
					<p className="legal-paragraph">
						{translate("terms.content.intellectual")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("terms.sections.liability")}
					</h2>
					<p className="legal-paragraph">
						{translate("terms.content.liability")}
					</p>
					<ul className="legal-list">
						<li>{translate("terms.content.liability1")}</li>
						<li>{translate("terms.content.liability2")}</li>
						<li>{translate("terms.content.liability3")}</li>
					</ul>
					<p className="legal-paragraph">
						{translate("terms.content.liability.purpose")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">
						{translate("terms.sections.deletion")}
					</h2>
					<p className="legal-paragraph">
						{translate("terms.content.deletion")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.changes")}</h2>
					<p className="legal-paragraph">
						{translate("terms.content.changes")}
					</p>
				</section>

				<section className="legal-section">
					<h2 className="legal-title">{translate("terms.sections.law")}</h2>
					<p className="legal-paragraph">{translate("terms.content.law")}</p>
				</section>
			</div>
		</div>
	);
};

export default Terms;
